import { useRef, useState } from 'react'
import { NavLink } from 'react-router-dom'

import { NAVIGATION } from 'constant/config'

import { useAuthStore } from 'stores/authStore'
import { useOutsideClick } from 'hooks/useOutsideClick'
import { useMediaQuery } from 'hooks/useMediaQuery'
import { fixed } from 'helpers/fixed'

import Button from 'components/Button'
import Reference from 'components/Reference'
import Icon from 'components/Icon'
import Account from 'modules/Account'
import Logo from 'modules/Logo'
import Menu from 'modules/Menu'
import AccountMenu from 'modules/AccountMenu'
import Languages from 'modules/Languages'

import style from './index.module.scss'

const Header = () => {
  const { auth, isAuth } = useAuthStore()
  const isMobile = useMediaQuery('(max-width: 1279px)')
  const [toggle, setToggle] = useState(false)
  const blockRef = useRef(null)

  useOutsideClick(
    blockRef,
    () => {
      setToggle(!toggle)
    },
    toggle
  )

  return (
    <header className={style.block}>
      <div className={style.container}>
        <Logo />
        {
          !isMobile &&
          <Menu />
        }
        <div
          ref={blockRef}
          className={style.right}
        >
          {
            isAuth() &&
            <NavLink
              to={NAVIGATION.wallet.url}
              className={style.balance}
              onClick={() => setToggle(false)}
            >
              <strong>{fixed(auth?.credits?.total_balance, 2)}</strong>
              <span> {auth?.currency.text}</span>
            </NavLink>
          }
          <Languages />
          <Reference
            to={NAVIGATION.search.url}
            classes={['secondary', 'md', 'circle']}
          >
            <Icon name={NAVIGATION.search.icon} />
          </Reference>
          {
            isAuth()
              ?
                <Button
                  classes={['secondary', 'md', 'circle']}
                  onChange={() => setToggle(!toggle)}
                >
                  <Icon name={'icon-human-avatar'} />
                </Button>
              :
                !isMobile && <Account />
          }
          {
            toggle &&
            <AccountMenu setToggle={setToggle} />
          }
        </div>
      </div>
    </header>
  )
}

export default Header
